import { useObserver } from 'mobx-react-lite'
import React, { FC, memo } from 'react'
import { useTranslation } from 'react-i18next'
import { makeStyles } from '@material-ui/core'
import IAReadOnlyField from './IAReadOnlyField'
import classNames from 'classnames'
import { CentricTypography } from '@core/component/CentricTypography'

interface IAWarehouseSizeQuantitiesProps {
  showProductSizes: boolean
  hasCaptureSize: boolean
  sizesList?: any
  deliveryWarehouseSizeQuantity: any
  deliveryWarehouseSizeQuantities: any
}

const useStyles = makeStyles(() => ({
  sizeQuantitiesContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    height: 'max-content',
    width: '100%'
  },
  totalSizes: {
    height: 90
  },
  lesserHeightSize: {
    height: 80
  },
  productSizeValue: {
    width: '60px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  singleSize: {
    height: 32,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  inactive: {
    opacity: '0.5'
  }
}))

const IAWarehouseSizeQuantities: FC<IAWarehouseSizeQuantitiesProps> = ({
  showProductSizes,
  hasCaptureSize,
  sizesList,
  deliveryWarehouseSizeQuantity,
  deliveryWarehouseSizeQuantities
}) =>
  useObserver(function useHook() {
    const { t } = useTranslation()
    const classes = useStyles()

    if (!hasCaptureSize) {
      return null
    }

    return (
      <div
        className={classes.sizeQuantitiesContainer}
        data-test-id='IAWarehouseSizeQuantities'
      >
        <div
          className={classNames(classes.totalSizes, {
            [classes.lesserHeightSize]: showProductSizes
          })}
        >
          <IAReadOnlyField
            label={t(
              'order.initialAllocation.deliveryWarehouseSizeQuantity',
              'IA Warehouse Sized QTY'
            )}
            value={deliveryWarehouseSizeQuantity}
            noBottomBorder={true}
          />
        </div>
        <div>
          {sizesList?.map(({ id: sizeId, isInactive = false }) => {
            return (
              <div
                key={sizeId}
                className={classNames(classes.singleSize, {
                  [classes.inactive]: isInactive
                })}
              >
                <CentricTypography
                  className={classes.productSizeValue}
                  variant={'h6DarkGrey'}
                >
                  {deliveryWarehouseSizeQuantities?.[sizeId] || 0}
                </CentricTypography>
              </div>
            )
          })}
        </div>
      </div>
    )
  })

export default memo(IAWarehouseSizeQuantities)
